/** @format */

import { useContext } from 'react';
import { CommonContext } from 'providers';

function useCommon() {
  return useContext(CommonContext);
}

export { useCommon };
